<template>
  <v-container class="single-column-layout" fluid>
    <router-view />
    <GlobalNotifications></GlobalNotifications>
  </v-container>
</template>

<script>
import GlobalNotifications from '@/components/GlobalNotifications'

export default {
  name: 'SingleColumnLayout',
  components: {
    GlobalNotifications
  }
}
</script>

<style lang="stylus">
.single-column-layout {
    .base {
        background-color #fff
    }
    background: var(--v-primary-base);
    background: linear-gradient(90deg, $color-accent 0%, var(--v-primary-base) 100%);
    height 100%
    display flex
    flex-direction column
    justify-content center
    align-items center
    img.logo {
        margin-bottom 10%
        height: 28px
    }
    img.illustration {
        max-height 80%
        max-width 80%
    }
}
</style>
